/**
 * Interpolated by app-index.ts into the inline dark-mode bootstrap script — that script
 * runs before hydration and can't import this module, so at least the prefix values
 * themselves have a single source of truth. Also consumed by the app's
 * `isDarkModeExcludedPath()` (src/shared/darkMode).
 */
export const DARK_MODE_EXCLUDED_PATH_PREFIXES: readonly string[] = ['/admin', '/legacy/admin'];

/**
 * Non-admin pages not yet styled for dark mode (e.g. the DM self-service response flow,
 * which hardcodes white surfaces), whose URL sits under a public resource so
 * DARK_MODE_EXCLUDED_PATH_PREFIXES can't express them without also excluding that
 * resource's other pages. Also interpolated by app-index.ts — see the note above.
 *
 * Patterns are case-insensitive to mirror React Router's default route matching.
 *
 * Temporary: remove an entry once its page renders correctly in dark mode.
 */
export const DARK_MODE_EXCLUDED_PATH_PATTERNS: readonly RegExp[] = [/^\/p\/[^/]+\/dm\/respond\/?$/i];
